module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box",
    staticStyle: {
      "overflow": "scroll !important"
    }
  }, [_c('div', [(_vm.row.group_list.length > 0) ? _c('van-collapse', {
    model: {
      value: (_vm.huiyiAcitiveCs),
      callback: function($$v) {
        _vm.huiyiAcitiveCs = $$v
      },
      expression: "huiyiAcitiveCs"
    }
  }, _vm._l((_vm.row.group_list), function(group, gindex) {
    return _c('van-collapse-item', {
      key: gindex,
      attrs: {
        "title": group.name,
        "name": gindex + 1
      }
    }, [_c('div', {
      staticClass: "train-box flex-between",
      staticStyle: {
        "flex-wrap": "wrap"
      }
    }, _vm._l((group.list), function(row, index) {
      return _c('div', {
        staticClass: "train-items",
        on: {
          "click": function($event) {
            return _vm.file(row)
          }
        }
      }, [_c('div', {
        staticClass: "train-items-top items-top1",
        style: ('background-image: linear-gradient(to right, #' + row.color[0] + ' , #' + row.color[1] + ');')
      }, [_c('div', [_c('div', {
        staticClass: "train-items-top-city"
      }, [_vm._v(_vm._s(row.location))]), _vm._v(" "), _c('div', {
        staticClass: "train-items-top-time"
      }, [_vm._v(_vm._s(row.date_str))])])]), _vm._v(" "), _c('div', {
        staticClass: "train-items-title"
      }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('div', {
        staticClass: "flex-between"
      }, [_c('div', {
        staticClass: "train-items-time"
      }, [_vm._v("相关文件 >")])])])
    }), 0)])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-766e90fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiPlan.vue
// module id = 2490
// module chunks = 0